import React from 'react';

// Overlay propio y no modal de Bootstrap: el backdrop de Bootstrap sobrevive a la navegación y deja
// la pantalla siguiente congelada (mismo criterio que TournamentCreateModal).
export default function TournamentOverlay({ title, onClose, width = 560, children, footer }) {
    return (
        <div style={{
            position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, background: 'rgba(15,23,42,.45)',
            zIndex: 1080, display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            padding: '5vh 16px', overflowY: 'auto',
        }} onClick={onClose}>
            <div className="card card-small" style={{ width, maxWidth: '100%' }} onClick={(e) => e.stopPropagation()}>
                <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                    <h6 className="m-0">{title}</h6>
                    <button type="button" className="btn btn-sm btn-white" onClick={onClose}>Cerrar</button>
                </div>
                <div className="card-body">{children}</div>
                {footer ? <div className="card-footer border-top">{footer}</div> : null}
            </div>
        </div>
    );
}

// Cajas de aviso con los colores que ya usa la pantalla de torneos.
export function Aviso({ tipo = 'info', children, style }) {
    const colores = {
        info: { background: '#F4F8FF', color: '#3D5170' },
        warn: { background: '#FFF8E8', color: '#6B4E16' },
        error: { background: '#FDECEA', color: '#8B2A20' },
        ok: { background: '#EAF8F0', color: '#1E6B43' },
    };
    return (
        <div style={{
            borderRadius: '.25rem', padding: '9px 11px', fontSize: 12.5, lineHeight: 1.45,
            marginBottom: 12, ...(colores[tipo] || colores.info), ...(style || {}),
        }}>{children}</div>
    );
}
